/**
 * ----------------------------------------------------------------------------------------------
 * individual JS for Product Page
 * ----------------------------------------------------------------------------------------------
 */

//カート追加
const addVariantToCart = (
  _variant_id,
  _variant_current_qty,
  _variant_inventory_quantity,
  _button_elem
) => {
  _button_elem.setAttribute("disabled", true);
  const current_qty = Number(_variant_current_qty),
    inventory_qty = Number(_variant_inventory_quantity),
    form_qty = 1;

  let formData = {
    items: [
      {
        id: Number(_variant_id),
        quantity: form_qty,
      },
    ],
  };

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      dataType: "json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data && typeof data.items === "undefined") {
        alert("在庫を超えて購入できませんでした。");
      }else{
        document.location = "/cart";
      }
      _button_elem.removeAttribute("disabled");
    })
    .catch((error) => {
      alert("エラーが発生しました。ページを再表示します。");
      _button_elem.removeAttribute("disabled");
      console.error("Error:", error);
      window.location.reload();
    });
  // }
};

// Back InStock アプリ呼び出し
const callBackInStock = (_variant_id) => {
  BIS.popup.show({ variantId: _variant_id });
};

//Variant選択時
const selectedVariant = (_this, _elem_type) => {
  const variant_id = _this.dataset.variant_id,
    variant_current_qty = _this.dataset.variant_current_qty;

  const variantPicker = document.querySelector('variant-picker');
  variantPicker.selectVariant(parseInt(variant_id));

  if (_elem_type === "purchase_btn") {
    addVariantToCart(
      variant_id,
      variant_current_qty,
      _this.dataset.variant_inventory_quantity,
      _this
    );
  } else if (_elem_type === "call_BIS") {
    callBackInStock(variant_id);
  }
};

// ポップアップを開く
const openPopup = (_id) => {
  document.getElementById(_id).classList.add("is-show");
  document.querySelector("body").classList.add("is-fixed");
}
// ポップアップを閉じる
const closePopup = (_id) => {
  document.getElementById(_id).classList.remove("is-show");
  document.querySelector("body").classList.remove("is-fixed");
}

// ポップアップのスマホ画面高さ調整(iPhone用)
const calcWindowGap = () => {
  const mediaQuery = window.matchMedia('(max-width:640px)');
  if (mediaQuery.matches) {
    document.getElementById("custom-product-form").style.height = window.innerHeight + "px";
  }else{
    document.getElementById("custom-product-form").style.height = "auto";
  }
}
window.addEventListener("DOMContentLoaded", calcWindowGap);
window.addEventListener("resize", calcWindowGap);

/* 2024.1.13 Add end バリエーション選択エリア */